// extracted by mini-css-extract-plugin
export default {"tab":"topTitle_tab__XbkDo","border-blue":"topTitle_border-blue__b03er","line":"topTitle_line__G9Rvx"};